module.exports = __webpack_public_path__ + "img/manda_040.2ab0ed33.png";